/*
create EvOccMappingComponen standalone, hope this can be easily use in somewhere else
  notes : uses micro service data modal
          perhas need a util convert/mapping from micro to event form data model in the future use
*/

import {
    Component,
    ChangeDetectionStrategy,
    Input,
    ChangeDetectorRef,
    ViewEncapsulation,
    OnInit,
    signal,
    computed,
    Output,
    EventEmitter,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { S25IconComponent } from "../modules/s25-icon/s25.icon.component";
import { S25IconButtonComponent } from "./s25.icon.button.component";
import { Item } from "../pojo/Item";
import { OccurrenceI } from "../pojo/OccurrenceI";
import { S25Util } from "../util/s25-util";
import { S25Reservation, S25RmReservation } from "../modules/s25-event/ReservationI";
import { S25ItemI } from "../pojo/S25ItemI";
import { EventService } from "../services/event.service";
import { S25ReservationUtil } from "../modules/s25-event/utils/s25.reservation.util";
import { UserprefService } from "../services/userpref.service";
import { S25Datefilter } from "../modules/s25-dateformat/s25.datefilter.service";
import { dataI } from "../modules/s25-event/s25-event-occurrences/ev-occ-menu/ev-occ-menu.component";
import { S25EditableModule } from "../modules/s25-editable/s25.editable.module";
import { S25ItemModule } from "../modules/s25-item/s25.item.module";
import { EventOccUtil } from "../modules/s25-event/s25-event-occurrences/s25-event-occurrence/s25.event.occurrence.util";
import { ProfileListUtil } from "../modules/student-housing/profile/profile.list.util";
import { S25ProfileUtil } from "../modules/s25-event/utils/s25.profile.util";
import { S25EventOccurrencesService } from "../modules/s25-event/s25-event-occurrences/s25.event.occurrences.service";
import { BOARD_CONST } from "../modules/s25-swarm-schedule/s25.board.const";
import { Proto } from "../pojo/Proto";
import DowNumber = Proto.DowNumber;

interface Reservation {
    itemId: number;
    date: string;
    start: string;
    end: string;
    resources: S25ItemI[];
    locations: S25ItemI[];
}

@Component({
    imports: [S25EditableModule, S25IconComponent, S25IconButtonComponent, S25ItemModule, FormsModule, CommonModule],
    selector: "s25-ng-occ-mapping",
    template: `@if (init) {
        <div class="c-margin-bottom--single c-margin-top--single" aria-label="Copy Segment Occurrences" tabindex="0">
            <div class="ngBold">
                @if (repetitionText) {
                    <div>Initial Segment: {{ repetitionText }}</div>
                }
                @if (newRsrvRepetitionText && removeMappingItems.length === 0) {
                    <div>Copy Segment: {{ newRsrvRepetitionText }}</div>
                }
            </div>
            <div class="copy-segment-container c-margin-top--half">
                <section class="input-data">
                    <label class="c-margin-bottom--quarter c-margin-top--half" for="segmentName"> Segment Name</label>
                    @if (profileName()) {
                        <s25-ng-editable-text
                            class="segmentName"
                            [allowEmpty]="false"
                            [min]="2"
                            [max]="40"
                            [alwaysEditing]="true"
                            [val]="profileName()"
                            (valChange)="profileName.set($event)"
                        ></s25-ng-editable-text>
                    }
                    <label class="c-margin-bottom--quarter c-margin-top--half" for="startDateContainer"
                        >Start Date and Time</label
                    >

                    <s25-ng-editable-start-end-datetime
                        [startDatetime]="startDate"
                        (startDatetimeChange)="onDateTimeChange($event, 'start')"
                        [endDatetime]="endDate"
                        (endDatetimeChange)="onDateTimeChange($event, 'end')"
                        [noTimeUpdated]="true"
                    >
                    </s25-ng-editable-start-end-datetime>

                    <label class="c-margin-top--half" for="occurrenceDetails"> Occurrence Mapping </label>
                    <select
                        class="ngListPageDropdown c-margin-bottom--half"
                        [(ngModel)]="mapping"
                        (ngModelChange)="updateMapping()"
                        id="occurrenceDetails"
                        name="occurrenceDetails"
                    >
                        <option value="one-by-one">One-to-one</option>
                        <option value="date-by-date">Date-to-date</option>
                        <option value="none">No Mapping</option>
                    </select>

                    <section class="c-margin-top--half">
                        @if (repetitionText && removeMappingItems.length > 0) {
                            <section class="cn-alert cn-alert--info cn-alert--notRealConflict">
                                <section class="cn-alert__icon cn-icon cn-alert__icon--blue" name="alert--info">
                                    Warning: Selecting “Remove” will remove the repeating pattern from the event
                                    segment.
                                </section>
                            </section>
                        }
                    </section>
                </section>

                <div class="divider"></div>
                <section class="occurrence-panel">
                    <div class="copy-object-toolbar">
                        <label class="copy-object-toolbar__filter">
                            Filter objects
                            <input
                                type="search"
                                class="c-input"
                                placeholder="Search by name"
                                [ngModel]="copyObjectFilterText()"
                                (ngModelChange)="copyObjectFilterText.set($event)"
                            />
                        </label>
                        @if (copyObjectFilterText().trim()) {
                            <button
                                type="button"
                                class="aw-button aw-button--outline"
                                (click)="clearCopyObjectFilter()"
                            >
                                Clear filter
                            </button>
                        }
                        <button
                            type="button"
                            class="aw-button aw-button--danger--outline"
                            (click)="removeAllCopyLocations()"
                            [disabled]="!hasCopyLocations()"
                        >
                            Remove All Locations
                        </button>
                        <button
                            type="button"
                            class="aw-button aw-button--danger--outline"
                            (click)="removeAllCopyResources()"
                            [disabled]="!hasCopyResources()"
                        >
                            Remove All Resources
                        </button>
                    </div>
                    @if (restorableLocationEntries().length || restorableResourceEntries().length) {
                        <section class="copy-object-restore">
                            <p class="copy-object-restore__title">Removed objects — select to re-add</p>
                            <div class="copy-object-restore__list">
                                @for (location of restorableLocationEntries(); track location.itemId) {
                                    <div class="copy-object-restore__row">
                                        <s25-item
                                            [itemId]="location.itemId"
                                            [itemTypeId]="Item.Ids.Location"
                                            [itemName]="location.itemName"
                                            [includeTypeIcon]="true"
                                        ></s25-item>
                                        <button
                                            type="button"
                                            class="aw-button aw-button--outline"
                                            (click)="restoreCopyLocation(location.itemId!)"
                                        >
                                            Re-add
                                        </button>
                                    </div>
                                }
                                @for (resource of restorableResourceEntries(); track resource.itemId) {
                                    <div class="copy-object-restore__row">
                                        <s25-item
                                            [itemId]="resource.itemId"
                                            [itemTypeId]="Item.Ids.Resource"
                                            [itemName]="resource.itemName"
                                            [includeTypeIcon]="true"
                                        ></s25-item>
                                        <button
                                            type="button"
                                            class="aw-button aw-button--outline"
                                            (click)="restoreCopyResource(resource.itemId!)"
                                        >
                                            Re-add
                                        </button>
                                    </div>
                                }
                            </div>
                        </section>
                    }
                    <section class="occurrence-view">
                        @for (res of reservations; track res.itemId; let occIndex = $index) {
                            <div class="original-occurrence" [ngClass]="{ 'date-mapped': mapping === 'date-by-date' }">
                                <div class="occurrence-date" [ngClass]="{ mapped: showMapping }">
                                    <div>{{ res.date }}</div>
                                </div>
                                <div class="occurrence-times">
                                    <div>{{ res.start }}</div>
                                    <div>{{ res.end }}</div>
                                </div>

                                <div>
                                    @for (location of res.locations; track location.itemId + "-" + i; let i = $index) {
                                        <div>
                                            <s25-item
                                                [itemId]="location.itemId"
                                                [itemTypeId]="Item.Ids.Location"
                                                [hideLabel]="false"
                                                [includeTypeIcon]="true"
                                            ></s25-item>
                                        </div>
                                    }
                                    @for (resource of res.resources; track resource.itemId + "-" + i; let i = $index) {
                                        <div>
                                            <s25-item
                                                [itemId]="resource.itemId"
                                                [itemTypeId]="Item.Ids.Resource"
                                                [includeTypeIcon]="true"
                                            ></s25-item>
                                        </div>
                                    }
                                </div>

                                <div class="mapped-occurrence">
                                    <s25-ng-icon [type]="'arrowRightDown'" [ariaLabel]="'maps to'" />

                                    <div class="occurrence-date">{{ newReservations[occIndex].date }}</div>
                                    <div class="occurrence-times">
                                        <div>{{ newReservations[occIndex].start }}</div>
                                        <div>{{ newReservations[occIndex].end }}</div>
                                    </div>
                                    <div
                                        class="occurrence-objects"
                                        [ngClass]="{
                                            'no-details':
                                                !newReservations[occIndex].locations?.length &&
                                                !newReservations[occIndex].resources?.length,
                                        }"
                                    >
                                        @if (
                                            !newReservations[occIndex].locations?.length &&
                                            !newReservations[occIndex].resources?.length
                                        ) {
                                            <div class="no-details">No Additional Details Found</div>
                                        }
                                        @for (
                                            location of newReservations[occIndex].locations;
                                            track location.itemId;
                                            let locIndex = $index
                                        ) {
                                            @if (matchesCopyObjectFilter(location.itemName)) {
                                                <div class="copy-object-row">
                                                    <s25-item
                                                        [itemId]="location.itemId"
                                                        [itemTypeId]="Item.Ids.Location"
                                                        [itemName]="location.itemName"
                                                        [hideLabel]="false"
                                                        [includeTypeIcon]="true"
                                                    ></s25-item>
                                                    <s25-ng-icon-button
                                                        [type]="'close'"
                                                        [ariaLabel]="'Remove ' + (location.itemName || 'location')"
                                                        (clicked)="removeCopyLocation(location.itemId!)"
                                                    />
                                                </div>
                                            }
                                        }
                                        @for (
                                            resource of newReservations[occIndex].resources;
                                            track resource.itemId;
                                            let resIndex = $index
                                        ) {
                                            @if (matchesCopyObjectFilter(resource.itemName)) {
                                                <div class="copy-object-row">
                                                    <s25-item
                                                        [itemId]="resource.itemId"
                                                        [itemTypeId]="Item.Ids.Resource"
                                                        [itemName]="resource.itemName"
                                                        [includeTypeIcon]="true"
                                                    ></s25-item>
                                                    <s25-ng-icon-button
                                                        [type]="'close'"
                                                        [ariaLabel]="'Remove ' + (resource.itemName || 'resource')"
                                                        (clicked)="removeCopyResource(resource.itemId!)"
                                                    />
                                                </div>
                                            }
                                        }
                                    </div>
                                </div>
                                @if (newReservations.length > 1) {
                                    <div>
                                        <span class="ngBold ngBlock remove-mapping">
                                            <input
                                                type="checkbox"
                                                id="{{ newReservations[occIndex].start }}"
                                                (change)="onCheck($event, newReservations[occIndex].itemId)"
                                            />
                                            Remove this mapping date
                                        </span>
                                    </div>
                                }
                            </div>
                        }
                    </section>
                </section>
            </div>
            <button class="aw-button aw-button--outline c-margin-top--half" (click)="onSubmit()">Submit</button>
        </div>
    } `,
    styles: [
        `
            .copy-segment-container {
                display: flex;
                align-items: flex-start;
                font-size: 0.9rem;
                font-weight: 400;
            }

            .occurrence-panel {
                display: flex;
                flex-direction: column;
                flex: 1 1 auto;
                min-width: 0;
                padding-left: 20px;
            }

            .copy-object-toolbar {
                display: flex;
                flex-wrap: wrap;
                align-items: flex-end;
                gap: 0.5rem 0.75rem;
                margin-bottom: 0.75rem;
                max-width: 55em;
            }

            .copy-object-toolbar__filter {
                display: flex;
                flex-direction: column;
                gap: 0.25rem;
                flex: 1 1 12rem;
                min-width: 10rem;
            }

            .copy-object-restore {
                margin-bottom: 0.75rem;
                max-width: 55em;
            }

            .copy-object-restore__title {
                margin: 0 0 0.5rem;
                font-weight: 600;
            }

            .copy-object-restore__list {
                display: flex;
                flex-direction: column;
                gap: 0.35rem;
            }

            .copy-object-restore__row {
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
                gap: 0.5rem;
            }

            .copy-object-row {
                display: flex;
                align-items: flex-start;
                gap: 0.25rem;
            }

            .input-data {
                display: flex;
                flex-direction: column;
                padding-right: 20px;
            }

            .divider {
                border-left: 1px solid #e5e5e5;
            }

            .start-date-container {
                display: flex;
                flex-direction: column;
            }

            .occurrence-view {
                max-width: 55em;
                width: 100%;
                height: fit-content;
                max-height: 26em;
                overflow-y: auto;
                box-shadow:
                    rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
                    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
            }

            .original-occurrence {
                padding: 10px;
            }

            .original-occurrence:nth-of-type(even) {
                background-color: rgba(230, 230, 250, 0.5);
            }

            .original-occurrence:not(:last-child) {
                border-bottom: 1px solid #d3d3d3;
            }

            .original-occurrence,
            .mapped-occurrence {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                gap: 2em;
            }

            .occurrence-date {
                width: 10em;
            }

            .mapped .occurrence-date {
                position: relative;
                top: 5px;
                width: 15em;
            }

            .mapped .occurrence-date div {
                width: 10em;
            }

            .mapped .occurrence-date span {
                position: relative;
                display: inline-block;
                width: 9em;
            }

            .mapped .occurrence-date span:not(.multi-line) {
                top: 4px;
            }

            .mapped .occurrence-date span.multi-line {
                top: 13px;
            }

            .mapped .multi-line {
                top: 13px;
            }

            .c-svgIcon {
                height: 3em;
                width: 2em;
            }

            .occurrence-objects .no-details {
                position: relative;
                left: 1em;
                font-size: 18px;
                color: #6c6c6c;
            }

            .original-occurrence.date-mapped {
                gap: 1.8em;
            }

            .mapped-occurrence {
                flex-basis: 100%;
                gap: 1em;
            }

            .mapped-occurrence .occurrence-date {
                width: 9em;
            }

            .mapped-occurrence .c-svgIcon {
                position: relative;
                height: 3em;
                width: 2em;
                bottom: 5px;
            }

            :host ::ng-deep .s25-item-holder {
                align-items: flex-start;
                gap: 5px;
                display: flex; /* Use flexbox to arrange child elements in a row */
                flex-wrap: nowrap; /* Prevent wrapping of elements */
            }

            :host ::ng-deep .s25-item-holder .s25-item-label {
                max-width: 21em;
                margin-left: 10px;
            }

            .remove-mapping {
                margin-left: 30px;
                margin-top: -25px;
            }
        `,
    ],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class EvOccMappingComponent implements OnInit {
    @Input() startDate: Date;
    @Input() endDate: Date;
    @Input() rsrvs: S25Reservation[];
    @Input() sourceProfileCode?: string;
    @Output() modelValueChange: EventEmitter<dataI> = new EventEmitter<dataI>();

    init: boolean = false;
    showMapping: boolean = true;
    profileName = signal<string>("");
    newProfileId = signal<number>(0);
    mapping: OccurrenceI.Mapping = "one-by-one";
    newRsrvs: S25Reservation[] = [];
    allLocations: S25ItemI[] = [];
    allResources: S25ItemI[] = [];
    newReservations: Reservation[] = []; // temporary  rsrv based on current mapping/date selections for displaying on visual aid
    reservations: Reservation[] = []; //   original rsrv
    dateFormat: string;
    timeFormat: string;
    isMultipleDays: boolean;
    diffStartMins: number = 0;
    diffEndMins: number = 0;
    repetitionText: string;
    removeMappingItems: number[] = [];
    newRsrvProfileCode: string = "";
    newRsrvRepetitionText: string;

    readonly copyObjectFilterText = signal("");
    readonly excludedLocationIds = signal<Set<number>>(new Set());
    readonly excludedResourceIds = signal<Set<number>>(new Set());
    readonly restorableLocations = signal<Map<number, S25RmReservation>>(new Map());
    readonly restorableResources = signal<Map<number, S25RmReservation>>(new Map());
    readonly restorableLocationEntries = computed(() => [...this.restorableLocations().values()]);
    readonly restorableResourceEntries = computed(() => [...this.restorableResources().values()]);

    protected readonly Item = Item;

    constructor(
        private cd: ChangeDetectorRef,
        private occurrencesService: S25EventOccurrencesService,
    ) {}

    async ngOnInit() {
        if (this.sourceProfileCode) {
            this.repetitionText = EventOccUtil.getRepetitionText(this.sourceProfileCode);
        }
        await this.loadPreferences();
        await this.setupProfile();
        await this.loadReservations();
        this.init = true;
        this.cd.detectChanges();
    }

    async loadPreferences() {
        const [dateFormat, timeFormat] = await Promise.all([
            UserprefService.getS25Dateformat(),
            UserprefService.getS25Timeformat(),
        ]);
        this.dateFormat = dateFormat;
        this.timeFormat = timeFormat;
    }

    async setupProfile() {
        const profileId = await EventService.getNewProfileId();
        this.newProfileId.set(profileId);
        this.profileName.set("Segment_" + profileId);
    }

    async loadReservations() {
        this.rsrvs.sort((a, b) => (a.eventStart as Date).getTime() - (b.eventEnd as Date).getTime());
        this.diffStartMins = S25Util.date.diffMinutes(this.rsrvs[0].eventStart, this.startDate);
        this.diffEndMins = S25Util.date.diffMinutes(this.rsrvs[0].eventEnd, this.endDate);
        await this.getNewRsrvs();
        const getAllObjs = await S25ReservationUtil.getRsrvsObjects(this.rsrvs, true, false);
        this.allLocations = getAllObjs?.allLocations as S25ItemI[];
        this.allResources = getAllObjs?.allResources as S25ItemI[];
    }

    async onDateTimeChange(newDate: Date, text: "start" | "end") {
        if (text === "start") {
            this.startDate = newDate;
            this.diffStartMins = S25Util.date.diffMinutes(this.rsrvs[0].eventStart, newDate);
        } else {
            this.endDate = newDate;
            this.diffEndMins = S25Util.date.diffMinutes(this.rsrvs[0].eventEnd, newDate);
            this.diffStartMins !== 0 ? (this.showMapping = true) : (this.showMapping = false);
        }
        await this.getNewRsrvs();
        this.showMapping = S25Util.date.getDate(this.endDate) > S25Util.date.getDate(this.startDate);
        this.cd.detectChanges();
    }

    async updateMapping() {
        await this.getNewRsrvs();
        this.cd.detectChanges();
    }

    async getNewRsrvs() {
        let rsrvsIds: number[] = [];
        if (this.newRsrvs?.length > 0) rsrvsIds = await S25Util.toItemIds(this.newRsrvs); // alreay created new set newRsrvs, just update DateTime/mapping changed
        this.newRsrvs = await S25ReservationUtil.duplicateReservations(
            this.rsrvs,
            this.diffStartMins,
            this.mapping,
            this.sourceProfileCode,
            this.diffEndMins,
            rsrvsIds,
        );
        this.applyObjectExclusionsToNewRsrvs();
        this.reservations = await this.getDisplayData(this.rsrvs);
        this.newReservations = await this.getDisplayData(this.newRsrvs);
        await this.getNewRsrvRepetitionText();
    }

    matchesCopyObjectFilter(itemName: string | undefined): boolean {
        const query = this.copyObjectFilterText().trim().toLowerCase();
        if (!query) {
            return true;
        }
        return (itemName ?? "").toLowerCase().includes(query);
    }

    clearCopyObjectFilter(): void {
        this.copyObjectFilterText.set("");
        this.cd.detectChanges();
    }

    hasCopyLocations(): boolean {
        return this.collectCopyObjectIds("location").length > 0;
    }

    hasCopyResources(): boolean {
        return this.collectCopyObjectIds("resource").length > 0;
    }

    removeCopyLocation(itemId: number): void {
        if (!Number.isFinite(itemId)) {
            return;
        }
        this.excludeAndRemoveLocation(itemId);
        void this.refreshNewReservationDisplay();
    }

    removeCopyResource(itemId: number): void {
        if (!Number.isFinite(itemId)) {
            return;
        }
        this.excludeAndRemoveResource(itemId);
        void this.refreshNewReservationDisplay();
    }

    removeAllCopyLocations(): void {
        const locationIds = this.collectCopyObjectIds("location");
        for (const locationId of locationIds) {
            this.stashLocationForRestore(locationId);
        }
        this.excludedLocationIds.update((excluded) => {
            const next = new Set(excluded);
            locationIds.forEach((locationId) => next.add(locationId));
            return next;
        });
        for (const rsrv of this.newRsrvs) {
            S25ReservationUtil.removeLocationsById(rsrv, locationIds);
        }
        void this.refreshNewReservationDisplay();
    }

    removeAllCopyResources(): void {
        const resourceIds = this.collectCopyObjectIds("resource");
        for (const resourceId of resourceIds) {
            this.stashResourceForRestore(resourceId);
        }
        this.excludedResourceIds.update((excluded) => {
            const next = new Set(excluded);
            resourceIds.forEach((resourceId) => next.add(resourceId));
            return next;
        });
        for (const rsrv of this.newRsrvs) {
            S25ReservationUtil.removeResourceById(rsrv, resourceIds);
        }
        void this.refreshNewReservationDisplay();
    }

    restoreCopyLocation(itemId: number): void {
        if (!Number.isFinite(itemId)) {
            return;
        }
        const location = this.restorableLocations().get(itemId);
        if (!location) {
            return;
        }
        this.excludedLocationIds.update((excluded) => {
            const next = new Set(excluded);
            next.delete(itemId);
            return next;
        });
        this.restorableLocations.update((restorable) => {
            const next = new Map(restorable);
            next.delete(itemId);
            return next;
        });
        for (const rsrv of this.newRsrvs) {
            this.addLocationItemToRsrv(rsrv, location);
        }
        void this.refreshNewReservationDisplay();
    }

    restoreCopyResource(itemId: number): void {
        if (!Number.isFinite(itemId)) {
            return;
        }
        const resource = this.restorableResources().get(itemId);
        if (!resource) {
            return;
        }
        this.excludedResourceIds.update((excluded) => {
            const next = new Set(excluded);
            next.delete(itemId);
            return next;
        });
        this.restorableResources.update((restorable) => {
            const next = new Map(restorable);
            next.delete(itemId);
            return next;
        });
        for (const rsrv of this.newRsrvs) {
            this.addResourceItemToRsrv(rsrv, resource);
        }
        void this.refreshNewReservationDisplay();
    }

    private excludeAndRemoveLocation(itemId: number): void {
        this.stashLocationForRestore(itemId);
        this.excludedLocationIds.update((excluded) => new Set(excluded).add(itemId));
        for (const rsrv of this.newRsrvs) {
            S25ReservationUtil.removeLocationsById(rsrv, [itemId]);
        }
    }

    private excludeAndRemoveResource(itemId: number): void {
        this.stashResourceForRestore(itemId);
        this.excludedResourceIds.update((excluded) => new Set(excluded).add(itemId));
        for (const rsrv of this.newRsrvs) {
            S25ReservationUtil.removeResourceById(rsrv, [itemId]);
        }
    }

    private applyObjectExclusionsToNewRsrvs(): void {
        const locationIds = [...this.excludedLocationIds()];
        const resourceIds = [...this.excludedResourceIds()];
        if (!locationIds.length && !resourceIds.length) {
            return;
        }
        for (const rsrv of this.newRsrvs) {
            if (locationIds.length) {
                S25ReservationUtil.removeLocationsById(rsrv, locationIds);
            }
            if (resourceIds.length) {
                S25ReservationUtil.removeResourceById(rsrv, resourceIds);
            }
        }
    }

    private async refreshNewReservationDisplay(): Promise<void> {
        this.newReservations = await this.getDisplayData(this.newRsrvs);
        this.cd.detectChanges();
    }

    private collectCopyObjectIds(objectType: "location" | "resource"): number[] {
        const objectIds = new Set<number>();
        for (const rsrv of this.newRsrvs) {
            const container = objectType === "location" ? rsrv.locations?.[0] : rsrv.resources?.[0];
            if (!container) {
                continue;
            }
            S25ReservationUtil.getObjectsFlat(container).forEach((item) => {
                if (item?.itemId != null) {
                    objectIds.add(item.itemId);
                }
            });
        }
        return [...objectIds];
    }

    private stashLocationForRestore(itemId: number): void {
        if (this.restorableLocations().has(itemId)) {
            return;
        }
        for (const rsrv of this.newRsrvs) {
            const found = S25ReservationUtil.getObjectsFlat(rsrv.locations?.[0]).find((item) => item.itemId === itemId);
            if (found) {
                this.restorableLocations.update((restorable) => {
                    const next = new Map(restorable);
                    next.set(itemId, S25Util.deepCopy(found) as S25RmReservation);
                    return next;
                });
                return;
            }
        }
    }

    private stashResourceForRestore(itemId: number): void {
        if (this.restorableResources().has(itemId)) {
            return;
        }
        for (const rsrv of this.newRsrvs) {
            const found = S25ReservationUtil.getObjectsFlat(rsrv.resources?.[0]).find((item) => item.itemId === itemId);
            if (found) {
                this.restorableResources.update((restorable) => {
                    const next = new Map(restorable);
                    next.set(itemId, S25Util.deepCopy(found) as S25RmReservation);
                    return next;
                });
                return;
            }
        }
    }

    private addLocationItemToRsrv(rsrv: S25Reservation, location: S25RmReservation): void {
        if (!rsrv.locations?.length) {
            rsrv.locations = [{ reserved: [], draft: [], requested: [] }];
        }
        const container = rsrv.locations![0];
        if (!container.reserved) {
            container.reserved = [];
        }
        if (container.reserved.some((item) => item.itemId === location.itemId)) {
            return;
        }
        container.reserved.push(S25Util.deepCopy(location));
    }

    private addResourceItemToRsrv(rsrv: S25Reservation, resource: S25RmReservation): void {
        if (!rsrv.resources?.length) {
            rsrv.resources = [{ reserved: [], draft: [], requested: [] }];
        }
        const container = rsrv.resources![0];
        if (!container.reserved) {
            container.reserved = [];
        }
        if (container.reserved.some((item) => item.itemId === resource.itemId)) {
            return;
        }
        container.reserved.push(S25Util.deepCopy(resource));
    }

    async getDisplayData(data: S25Reservation[]): Promise<Reservation[]> {
        const results: Reservation[] = [];
        data.forEach((res: S25Reservation, i: number) => {
            const isMultipleDays = S25Util.date.getDate(this.endDate) > S25Util.date.getDate(this.startDate);
            const dateRange =
                isMultipleDays &&
                `${S25Datefilter.transform(res.eventStart, this.dateFormat)} - ${S25Datefilter.transform(
                    res.eventEnd,
                    this.dateFormat,
                )}`;
            this.isMultipleDays = isMultipleDays;
            const [resources, locations] = [
                S25ReservationUtil.getObjectsFlat(res.resources?.[0]) || [],
                S25ReservationUtil.getObjectsFlat(res.locations?.[0]) || [],
            ];
            results.push({
                itemId: res.itemId,
                date: dateRange || (S25Datefilter.transform(res.eventStart, this.dateFormat) as string),
                start: S25Datefilter.transform(res.eventStart, this.timeFormat) as string,
                end: S25Datefilter.transform(res.eventEnd, this.timeFormat) as string,
                resources: resources,
                locations: locations,
            });
        });

        return results;
    }

    onSubmit() {
        const newRsrvs = this.newRsrvs.filter((item) => !this.removeMappingItems.includes(item.itemId));
        //occ inline copy segment data, if use somewhere might need to ajust the emit data
        const data: dataI = {
            profileName: this.profileName(),
            profileId: this.newProfileId(),
            newCopyRsrvsData: newRsrvs,
            newProfileCode: this.newRsrvProfileCode,
        };
        this.modelValueChange.emit(data);
    }

    async onCheck($event: boolean, itemId: number) {
        if ($event && !this.removeMappingItems.includes(itemId)) {
            this.removeMappingItems.push(itemId);
        } else {
            const index = this.removeMappingItems.indexOf(itemId);
            if (index !== -1) this.removeMappingItems.splice(index, 1);
        }
        await this.getNewRsrvRepetitionText();

        this.cd.detectChanges();
    }

    async getNewRsrvRepetitionText() {
        if (this.removeMappingItems.length > 0) {
            this.newRsrvRepetitionText = "";
            this.newRsrvProfileCode = "";
            return;
        }
        const sourceProfileCode = this.sourceProfileCode;
        const lastOccEnd = this.newRsrvs.at(-1)?.eventEnd;
        if (sourceProfileCode && lastOccEnd) {
            let dows = this.newRsrvs.map(
                (rsrv: S25Reservation) => S25Util.date.parseDropTZ(rsrv.eventStart).getDay() as DowNumber,
            );
            dows = S25Util.array.unique(dows).sort();
            const dowsAbbr = dows.map((dow) => BOARD_CONST.dowInt2Abbr[dow]);
            this.newRsrvProfileCode = S25ProfileUtil.getNewProfileCode(sourceProfileCode, dowsAbbr, lastOccEnd);
            this.newRsrvRepetitionText = await EventOccUtil.getRepetitionText(this.newRsrvProfileCode);
        }
    }
}
